import * as React from "react";
import { Route, Routes } from "react-router";
import { useFeatureFlagEnabled } from "posthog-js/react";

import ProtectedRoute from "./ProtectedRoute";
import RestrictedRoute from "./RestrictedRoute";

import CabinetLayout from "layouts/CabinetLayout";
import CabinetDataLoader from "layouts/CabinetDataLoader";

// AUTH
import Auth from "pages/Auth/Auth";
import Login from "pages/Auth/Login";
import Register from "pages/Auth/Register";
import ForgotPassword from "pages/Auth/ForgotPassword";
import ResetPassword from "pages/Auth/ResetPassword";

import Google from "pages/Auth/Google";
import Facebook from "pages/Auth/Facebook";

// CABINET
import HomeMain from "pages/Home/Main";

import InvoicesMain from "pages/Invoices/Main";
import InvoiceDetails from "pages/Invoices/InvoiceDetails";

import AccountsMain from "pages/Accounts/Main";

import CreateInvoiceMain from "pages/CreateInvoice";

import ApiTokenMain from "pages/ApiToken/Main";
import BankIntegrationsMain from "pages/BankIntegrations/Main";

import SettingsMain from "pages/Settings/Main";

import ProfileMain from "pages/Profile/Main";
import SubscriptionMain from "pages/Subscription/Main";

import Support from "pages/Support";
import FAQ from "pages/FAQ";

import IbanQr from "pages/IbanQr";
import IbanOplata from "pages/IbanOplata";
import DynamicInvoice from "pages/DynamicInvoice";

import AutoService from "pages/SipIbanOplata/AutoService";
import Beauty from "pages/SipIbanOplata/Beauty";
import Hotels from "pages/SipIbanOplata/Hotels";
import OnlineSales from "pages/SipIbanOplata/OnlineSales";

import Subscriptions from "pages/Subscriptions";
import PrivacyPolicy from "pages/PrivacyPolicy";
import TermsOfService from "pages/TermsOfService";

import NotFound from "pages/NotFound";

import { routes } from "./routes";
import { featureFlag } from "shared/constants/posthog";

const Router: React.FC = () => {
  // TODO: remove after feature release
  const showIntegrations = useFeatureFlagEnabled(
    featureFlag.bank_integration_feature_enabled,
  );

  // TODO: remove after feature release
  const showInvoiceDetails = useFeatureFlagEnabled(
    featureFlag.invoice_details_feature_enabled,
  );

  return (
    <Routes>
      <Route path={routes.root} element={<IbanOplata />} />

      {/* SIP IBAN OPLATA */}
      <Route
        path={`${routes.sip}${routes.autoService}`}
        element={<AutoService />}
      />
      <Route path={`${routes.sip}${routes.beauty}`} element={<Beauty />} />
      <Route path={`${routes.sip}${routes.hotels}`} element={<Hotels />} />
      <Route
        path={`${routes.sip}${routes.onlineSales}`}
        element={<OnlineSales />}
      />

      {/* AUTH */}
      <Route element={<RestrictedRoute />}>
        <Route path={routes.auth} element={<Auth />} />

        <Route path={routes.login} element={<Login />} />
        <Route path={routes.register} element={<Register />} />
      </Route>
      <Route path={routes.forgotPassword} element={<ForgotPassword />} />
      <Route path={routes.resetPassword} element={<ResetPassword />} />

      <Route path={routes.google} element={<Google />} />
      <Route path={routes.facebook} element={<Facebook />} />

      {/* CABINET */}
      <Route element={<ProtectedRoute />}>
        <Route element={<CabinetDataLoader />}>
          <Route element={<CabinetLayout />}>
            <Route path={routes.home} element={<HomeMain />} />
            <Route path={routes.invoices} element={<InvoicesMain />} />
            {showInvoiceDetails && (
              <Route
                path={`${routes.invoices}/:ibanInvoiceUid`}
                element={<InvoiceDetails />}
              />
            )}
            <Route path={routes.accounts} element={<AccountsMain />} />

            <Route path={routes.apiToken} element={<ApiTokenMain />} />
            {showIntegrations && (
              <Route
                path={routes.integrations}
                element={<BankIntegrationsMain />}
              />
            )}
            <Route path={routes.settings} element={<SettingsMain />} />

            <Route path={routes.profile} element={<ProfileMain />} />
            <Route path={routes.subscription} element={<SubscriptionMain />} />

            <Route path={routes.support} element={<Support />} />
            <Route path={routes.faq} element={<FAQ />} />
          </Route>

          <Route path={routes.createInvoice} element={<CreateInvoiceMain />} />
        </Route>
      </Route>

      {/* PUBLIC */}
      <Route path={routes.ibanOplata} element={<IbanOplata />} />
      <Route path={`${routes.ibanQr}/:uid`} element={<IbanQr />} />
      <Route
        path={`${routes.dynamicInvoice}/:uid`}
        element={<DynamicInvoice />}
      />

      <Route path={routes.subscriptions} element={<Subscriptions />} />
      <Route path={routes.publicOffer} element={<PrivacyPolicy />} />
      <Route path={routes.termsOfService} element={<TermsOfService />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Router;
